import CSS from 'csstype';
import { useRef, lazy, Suspense } from 'react';
import { FoodService } from '../../controllers/FoodService';
import FoodCardList from './components/FoodCardList';

const CategoriesSwiper = lazy(() => import('../../components/badges/CategoriesSwiper'));

const BreakfastSection = () => {

    const refs = {
        'Desayuno': useRef(null),
        'Bebidas': useRef(null)
    };

    const categories = [
        {
            nameEs: 'Desayuno',
            action: ''
        },
        {
            nameEs: 'Bebidas',
            action: ''
        }
    ];

    const alimentos: any[] = FoodService.getAlimentos();
    const bebidas: any[] = FoodService.getBebidas();

    const scrollToSection = (e) => {
        refs[e.text].current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    return (
        <>
            <div className='flex justify-start items-start'>
                <img src="/assets/img/icons/clock-icon.svg" alt="Clock icon" />
                <div className='ml-4 flex flex-col'>
                    <span style={timeTextStyles}>
                        07:00 a.m. - 12:00
                    </span>
                    <span className='mt-2' style={hourTextStyles}>
                        Horarios en días de la Semana
                    </span>
                </div>
            </div>

            <br />
            <p>
                Estimado huésped, los tiempos de preparación de elementos son de aproximadamente 30 a 60 minutos dependiendo la demanda.
            </p>
            <br />


            <Suspense fallback={<div>Cargando</div>}>
                <CategoriesSwiper categories={categories} select={scrollToSection} />
            </Suspense>

            <div ref={refs['Desayuno']} className='mb-4 mt-4' style={typeFoodstyles}>
                Alimentos
            </div>

            <div className='w-full'>
                <FoodCardList items={alimentos} />
            </div>

            <div ref={refs['Bebidas']} className='mb-4' style={typeFoodstyles}>
                Bebidas
            </div>

            <div className='w-full'>
                <FoodCardList items={bebidas} />
            </div>
        </>
    )
}

const hourTextStyles: CSS.Properties = {
    color: '#67BAAF',
    fontSize: '14px',
    lineHeight: '14px'
}

const timeTextStyles: CSS.Properties = {
    color: '#4B5563'
}

const typeFoodstyles: CSS.Properties = {
    fontSize: '18px',
    fontWeight: '600',
    color: '#012349',
    lineHeight: '18px'
}

export default BreakfastSection;
